import React from "react";
import { GraduationCap } from "lucide-react";
import { SectionFrame } from "./SectionFrame";
import { StatusBadge } from "../../StatusBadge";

const inPeriod = (isoTimestamp, period) => isoTimestamp && isoTimestamp.slice(0, 7) === period;

/** Monthly Record - Training section (spec item 8). Reuses the existing employee training
 * profile (trainingApi.employeeProfile) and only shows items with a date-bearing event
 * inside this period - the full lifetime record stays on the Training tab. */
export const TrainingSection = ({ data, period, loading, error, onRetry }) => {
  const assignments = (data?.assignments || []).filter((a) => inPeriod(a.assigned_at, period) || inPeriod(a.completed_at, period));
  const certifications = (data?.certifications || []).filter((c) => inPeriod(c.issued_at, period) || inPeriod(c.expires_at, period));
  const retraining = (data?.retraining || []).filter((r) => inPeriod(r.created_at, period) || inPeriod(r.completed_at, period));
  const isEmpty = assignments.length === 0 && certifications.length === 0 && retraining.length === 0;

  return (
    <SectionFrame
      title="Training" icon={GraduationCap} testId="monthly-training-section"
      loading={loading} error={error} onRetry={onRetry}
      isEmpty={isEmpty}
      emptyMessage="No training activity for this period."
    >
      {assignments.map((a) => (
        <div key={a.id} className="flex items-center justify-between py-2 border-t border-slate-100 first:border-t-0" data-testid={`monthly-training-assignment-${a.id}`}>
          <div>
            <p className="text-sm font-medium text-slate-700">{a.course_title || a.course_id}</p>
            <p className="text-xs text-slate-500">{inPeriod(a.completed_at, period) ? `Completed ${a.completed_at.slice(0, 10)}` : `Assigned ${a.assigned_at?.slice(0, 10)}`}</p>
          </div>
          <StatusBadge status={a.status} />
        </div>
      ))}
      {certifications.map((c) => (
        <div key={c.id} className="flex items-center justify-between py-2 border-t border-slate-100 first:border-t-0" data-testid={`monthly-training-cert-${c.id}`}>
          <div>
            <p className="text-sm font-medium text-slate-700">{c.certification_name || c.certification_key}</p>
            <p className="text-xs text-slate-500">{inPeriod(c.expires_at, period) ? `Expired ${c.expires_at.slice(0, 10)}` : `Issued ${c.issued_at?.slice(0, 10)}`}</p>
          </div>
          <StatusBadge status={c.status} />
        </div>
      ))}
      {retraining.map((r) => (
        <div key={r.id} className="flex items-center justify-between py-2 border-t border-slate-100 first:border-t-0" data-testid={`monthly-training-retraining-${r.id}`}>
          <p className="text-sm font-medium text-slate-700">{r.reason || r.course_id}</p>
          <StatusBadge status={r.status} />
        </div>
      ))}
    </SectionFrame>
  );
};
